export enum ChangeStatusEnum {
  NotChanged = 0,
  Changed = 1,
  New = 2,
}
